var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#33BC6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.42 23.8L24.2 21.04L23.36 20.2L21.42 22.1L20.64 21.32L19.8 22.18L21.42 23.8ZM12.4 14.8H22V13.2H12.4V14.8ZM22 26C20.8933 26 19.9499 25.6099 19.1696 24.8296C18.3893 24.0493 17.9995 23.1061 18 22C18 20.8933 18.3901 19.9499 19.1704 19.1696C19.9507 18.3893 20.8939 17.9995 22 18C23.1067 18 24.0501 18.3901 24.8304 19.1704C25.6107 19.9507 26.0005 20.8939 26 22C26 23.1067 25.6099 24.0501 24.8296 24.8304C24.0493 25.6107 23.1061 26.0005 22 26ZM10 25.2V10H24.4V16.94C24.1467 16.82 23.8867 16.72 23.62 16.64C23.3533 16.56 23.08 16.5 22.8 16.46V11.6H11.6V22.84H16.46C16.5267 23.2533 16.6301 23.6467 16.7704 24.02C16.9107 24.3933 17.0939 24.7467 17.32 25.08L17.2 25.2L16 24L14.8 25.2L13.6 24L12.4 25.2L11.2 24L10 25.2ZM12.4 21.2H16.46C16.5 20.92 16.56 20.6467 16.64 20.38C16.72 20.1133 16.82 19.8533 16.94 19.6H12.4V21.2ZM12.4 18H18.08C18.5867 17.5067 19.1768 17.1165 19.8504 16.8296C20.524 16.5427 21.2405 16.3995 22 16.4H12.4V18Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.c85595bde2c8dd30450db5c631539c67.svg";
export { ForwardRef as ReactComponent };